export default "__VITE_ASSET__$Kk41uFN__"